export const getDatePickerButton = (
  title: string,
  className: string,
  iconType?: "apply" | "clearAll",
) => {
  let icon: string = "";
  if (iconType === "apply") {
    icon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3513_10065)">
        <path d="M7 12L12 17L22 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2 12L7 17M12 12L17 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_3513_10065">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>`;
  } else if (iconType === "clearAll") {
    icon = `<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3717_1466)">
        <path d="M4.5 7H20.5" stroke="#009FDF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10.5 11V17" stroke="#009FDF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14.5 11V17" stroke="#1FABE7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5.5 7L6.5 19C6.5 19.5304 6.71071 20.0391 7.08579 20.4142C7.46086 20.7893 7.96957 21 8.5 21H16.5C17.0304 21 17.5391 20.7893 17.9142 20.4142C18.2893 20.0391 18.5 19.5304 18.5 19L19.5 7" stroke="#1FABE7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9.5 7V4C9.5 3.73478 9.60536 3.48043 9.79289 3.29289C9.98043 3.10536 10.2348 3 10.5 3H14.5C14.7652 3 15.0196 3.10536 15.2071 3.29289C15.3946 3.48043 15.5 3.73478 15.5 4V7" stroke="#1FABE7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_3717_1466">
          <rect width="24" height="24" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>`;
  }

  const btn = document.createElement("button");
  btn.innerHTML = `${icon}${title}`;
  btn.type = "button";
  btn.className = className;

  return btn;
};
